import { FC, useCallback } from 'react';
import { ProductBundle, ProductWithBundleId } from '~/models/CampaignModel';
import { BYOD_PRODUCT_ID, BYODProductBundle } from '~/store/campaign/byod.constants';
import { BringYourOwnDevice } from '../../campaign/components/product-group/components/bring-your-own-device/BringYourOwnDevice';
import { useBasket } from '../../campaign/useBasket';

const ByodProductWithBundleId = {
  ...BYODProductBundle.offers[0],
  bundleId: BYODProductBundle.id,
};
const ByodProductBundle: ProductBundle<ProductWithBundleId> = {
  ...BYODProductBundle,
  offers: [ByodProductWithBundleId],
};

export const ByodBundle: FC<{ group: ProductBundle<ProductWithBundleId>[] }> = ({ group }) => {
  const selectedProducts = useBasket((s) => s.selectedProducts);
  const selectProduct = useBasket((s) => s.selectProduct);
  const openBundle = useBasket((s) => s.openBundle);
  const showBundle = useBasket((s) => s.showBundle);
  const isByodSelected = selectedProducts.some((product) => product.id === BYOD_PRODUCT_ID);

  const onToggleByod = useCallback(() => {
    selectProduct(ByodProductWithBundleId, ByodProductBundle);
    if (isByodSelected) {
      // display the first bundle in receivers
      openBundle(group[0].id, true);
      showBundle(group[0].id, true);
    } else {
      // Close all receiver bundles
      group.forEach((bundle) => {
        openBundle(bundle.id, false);
        showBundle(bundle.id, false);
      });
    }
  }, [group, isByodSelected, selectProduct, openBundle, showBundle]);

  return <BringYourOwnDevice isBYODSelected={isByodSelected} clickHandler={onToggleByod} />;
};
